<template>
  <b-overlay :show="loading" rounded="sm" spinner-variant="primary">
    <transition name="bounce">
      <b-container class="py-5 custom-container container">
        <b-breadcrumb
          :items="items"
          class="pl-0 pt-5 mt-5 bg-transparent"
        ></b-breadcrumb>
        <b-row>
          <b-col
            ><h2 class="font-weight-bold">{{ filename }}</h2></b-col
          >

          <file-options
            v-if="file"
            :file="file"
            @showAlert="showAlert"
            @shareFile="shareFile"
          ></file-options>
        </b-row>

        <b-row class="mx-0 my-2">
          <b-card no-body class="preview">
            <b-img-lazy
              v-bind="mainProps"
              class="image"
              v-if="file"
              :src="fileSrc"
              alt="Image 1"
            ></b-img-lazy>
          </b-card>
        </b-row>
        <b-row class="mx-0 mt-4">
          <b-col sm="12" lg="8" md="8" class="d-flex flex-column"
            ><b-row class="preview-container" v-if="file">
              <b-col
                sm="6"
                lg="5"
                class="pl-0"
                v-for="image in file.files"
                :key="image.id"
              >
                <b-card no-body class="files "
                  ><b-img-lazy
                    v-bind="mainProps"
                    class="image"
                    :src="image.thumb_url"
                  ></b-img-lazy></b-card></b-col
            ></b-row>
            <b-row class="mt-auto">
              <b-col cols="12" class="mb-0">
                <b-card class="mt-4 file-details ">
                  <h5 class=" mb-4 font-weight-bold ">
                    File Details
                  </h5>
                  <b-card-body v-if="file" class="pl-0 align-items-center">
                    <b-row
                      class="mb-2"
                      v-for="info in file.file_information_types"
                      :key="info.id"
                    >
                      <b-col
                        cols="7"
                        sm="7"
                        md="4"
                        lg="4"
                        class="font-weight-bold gray--2"
                      >
                        {{ info.label }}
                      </b-col>
                      <b-col cols="5" sm="5" md="4" lg="4" class=" gray--2">
                        {{
                          info.field_type === 'date'
                            ? parseDate(info.value)
                            : info.value
                        }}
                      </b-col>
                    </b-row>
                    <b-row align-v="center" class="mt-5">
                      <b-col cols="12" md="5" class="mb-md-4 mb-3">
                        <b-button
                          class="w-100 btn-outlined bg-white text-dark"
                          variant="outline-secondary"
                          :style="'height: 64px !important;'"
                          :loading="loading"
                          :disabled="loading"
                          @click="
                            $router.replace({ name: 'request.files-page' })
                          "
                        >
                          Back
                        </b-button>
                      </b-col>
                      <b-col cols="12" md="2" class="mb-0"></b-col>
                      <b-col cols="12" md="5" class="mb-md-4 mb-3">
                        <b-button
                          type="submit"
                          class="w-100 h-auto float-right py-3"
                          variant="primary"
                          :style="'height: 64px !important;'"
                          :loading="loading"
                          :disabled="loading"
                          @click="submitFile"
                        >
                          Submit
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
          </b-col>

          <b-col v-if="file" sm="12" lg="4" md="4" class="upload-details"
            ><file-upload-details
              :file="file"
              @openShareFile="shareFile"
            ></file-upload-details>
          </b-col>
        </b-row>

        <share-file-modal
          :showShareFiles="showShareFiles"
          :selectedFiles="checkedFiles"
          :fileShares="fileShares"
          @closeShareFileModal="showShareFiles = false"
          @fileShareResponsePrompt="shareFileResponsePrompt"
        />

        <b-alert
          class="custom-alert"
          :show="dismissCountDown"
          :class="{
            'bg-danger border-danger': alertType === 'danger'
          }"
          dismissible
          fade
          :variant="alertType"
          @dismiss-count-down="countDownChanged"
        >
          {{ alertMsg }}
        </b-alert>
      </b-container>
    </transition>
  </b-overlay>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import FileOptions from '@/components/modals/FileOptions'
import FileUploadDetails from '@/components/cards/FileUploadDetails'
import ShareFileModal from '@/components/modals/ShareFileModal'

export default {
  components: {
    FileOptions,
    FileUploadDetails,
    ShareFileModal
  },
  data() {
    return {
      loading: false,
      mainProps: {
        center: true,
        blank: true,
        blankColor: '#bbb'
      },
      showShareFiles: false,
      checkedFiles: [],
      fileShares: [],
      dismissCountDown: 0,
      alertMsg: '',
      alertType: 'primary'
    }
  },

  computed: {
    ...mapState({
      file: state => state.file.file
    }),
    ...mapGetters('file', ['file']),
    ...mapGetters('requests', ['fileRequest']),
    filename() {
      return this.file ? this.file.name : ''
    },
    items() {
      return [
        {
          text: 'Files',
          to: '/file'
        },
        {
          text: this.filename
        }
      ]
    },
    fileSrc() {
      return this.file
        ? this.file.files.length
          ? this.file.files[0].thumb_url
          : `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='%230066FF' class='bi bi-file-earmark' viewBox='0 0 16 16'%3E%3Cpath d='M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z'/%3E%3C/svg%3E`
        : `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='%230066FF' class='bi bi-file-earmark' viewBox='0 0 16 16'%3E%3Cpath d='M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z'/%3E%3C/svg%3E`
    }
  },

  methods: {
    ...mapActions({
      getFile: 'file/getFile',
      fileRequestShare: 'requests/fileRequestShare'
    }),

    async fetchFile() {
      this.loading = true
      await this.getFile(this.$route.params.id)
      this.loading = false
    },
    shareFile() {
      this.fileShares = this.file.file_shares
      this.showShareFiles = true
    },
    shareFileResponsePrompt(res) {
      if (res.success) {
        this.alertMsg =
          'File shared successfully to selected emails: ' +
          res.data.success.join(', ')

        this.dismissCountDown = 15
        this.fetchFile()

        return
      } else {
        this.alertType = 'danger'

        if (res.status === 402) {
          this.alertMsg = 'File shared unsuccessful!'
        } else {
          this.alertMsg =
            'Something went wrong while submitting the share file email!'
        }
      }

      this.dismissCountDown = 5
    },
    async submitFile() {
      let formData = {
        fileRequestId: this.fileRequest,
        file: this.file.id
      }

      await this.fileRequestShare(formData)
        .then(res => {
          this.$router.replace({
            name: 'file.success-page',
            params: {
              id: this.file.id
            }
          })
        })
        .catch(error => {
          this.alertType = 'danger'
          this.dismissCountDown = 15
          this.alertMsg = error.data.message
        })
    },
    showAlert(action) {
      this.dismissCountDown = 1
      // this.alertMsg = action
      this.alertMsg = `File has been ${{ action }}.`
      if (action === 'deleted') {
        this.$router.replace({
          name: 'file.list-page'
        })
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    }
  },

  async created() {
    if (this.fileRequest === null) {
      this.$router
        .replace({
          name: 'requests.list-page'
        })
        .catch(() => {})
    }

    await this.fetchFile().then(() => {
      if (this.file) {
        this.checkedFiles.push(this.file.id)
      }
    })
  }
}
</script>
<style lang="scss" scoped>
.file-details {
  height: auto;
}
.card {
  border-radius: 8px;
  opacity: 1;
  margin: 0;
}
.preview {
  width: 1440px;
  height: 808px;

  @media (max-width: 767px) {
    display: none;
  }
}
.preview-container {
  height: 192px;
  flex-wrap: nowrap;

  @media (max-width: 767px) {
    width: auto;
  }
}
.files {
  height: 192px;
}
.image {
  margin: 0 !important;
  max-height: 100%;
}
.list {
  justify-content: space-around;
}
.upload-details {
  padding-right: 0;

  @media (max-width: 767px) {
    padding-left: 0;
    padding-top: 1.5rem;
  }
}
</style>
